
import { Vue, Component, Watch } from 'vue-property-decorator';
import { isWeiXin } from '@/common/ts/common';
import BottomTabbar from '@/components/next/BottomTabbar.vue';
import { getBaseInfo, userInfo, voteNum, workType } from './api';
import { namespace, State, Mutation } from 'vuex-class';

const baseUrl = '0325FSDS';
const fengShangModule = namespace('fengShang');

@Component({
  components: {
    BottomTabbar,
  },
})
export default class ViewHolder extends Vue {
  @State('userId') userId: any;
  @fengShangModule.Mutation setActivityId!: (num: number) => void;
  @fengShangModule.Mutation setUserId!: (num: number) => void;
  @fengShangModule.Mutation setBalance!: (num: number) => void;
  @fengShangModule.Mutation setUserInfo!: (num: number) => void;
  @fengShangModule.Mutation setActivityInfo!: (data: any) => void;
  tabs: any[] = [
    {
      title: '首页',
      path: `/${baseUrl}/list`,
      id: 1,
    },
    {
      title: '活动背景',
      path: `/${baseUrl}/home`,
      id: 2,
    },
    {
      title: '活动规则',
      path: `/${baseUrl}/rule`,
      id: 3,
    },
  ];
  activeTab = 0;
  baseInfo: any = {};
  @Watch('$route', { immediate: true })
  onRouteChange() {
    // 设置分享文案
    const cover =
      'https://image2.cqcb.com/1075dd015b5d3b3545e6379f33081b4e.jpeg';
    // App分享
    this.$appShareInfo({
      title: '2021西部怡美新女性风尚大赛',
      url: location.href,
      subtitle: `2021西部怡美新女性风尚大赛`,
      classId: -1,
      id: -1,
      image: cover,
      type: 3,
    });
    // 微信分享
    if (isWeiXin()) {
      this.$wxShareInfo({
        title: '2021西部怡美新女性风尚大赛',
        subtitle: `2021西部怡美新女性风尚大赛`,
        image: cover,
      });
    }
  }

  async created() {
    const index = this.tabs.findIndex((item: any) => {
      return item.path === this.$route.path;
    });
    this.activeTab = index > -1 ? index : 0;
    const ret = await getBaseInfo();
    this.baseInfo = ret.data;
    // 添加pv统计
    if (this.baseInfo.activityId) {
      this.$addPv(this.baseInfo.activityId);
    }
    this.setActivityId(this.baseInfo.act_id);
    this.setActivityInfo(this.baseInfo);
    // 用户信息
    const user: any = await userInfo(this.baseInfo.act_id);
    if (user.code === 200) {
      this.setUserId(user.data.userid);
      this.setUserInfo(user.data);
    }
    // 余额
    const balance: any = await voteNum(this.baseInfo.act_id);
    if (balance.code === 200) {
      this.setBalance(balance.data);
    }
    //  workType
    const res: any = await workType();
  }
}
